import {connect} from 'react-redux';
import {HeatBlock as Component} from './HeatBlock';
import {
  createHeatBlock,
  pushInteractions,
  setModal,
  showModal

} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("heatBlocks") &&
     state.notebook.protocolSection.scene.apparatus.heatBlocks.some(
       heatBlock => heatBlock.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      active: state.notebook.protocolSection.scene.apparatus.heatBlocks[ownProps.id-1].active,
      temp: state.notebook.protocolSection.scene.apparatus.heatBlocks[ownProps.id-1].temp,
      timer: state.notebook.protocolSection.scene.apparatus.heatBlocks[ownProps.id-1].timer,
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createHeatBlock: (data) => {
      dispatch(createHeatBlock(data))
    },
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
    setModal: (data) => {
      dispatch(setModal(data))
    },
    showModal: (data) => {
      dispatch(showModal(data))
    }
  };
}

export const HeatBlock = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
